<div style="width: 100%">
  <ins class="adsbygoogle"
       style="display:block;"
       data-ad-client="ca-pub-3718687875065443"></ins>
  <!--data-ad-format="auto"-->
  <!--[attr.data-ad-slot]="data"-->
</div>
<br>  
